import Dashboard from './view'

export default Dashboard
